export class Numbers {
  public static round2Decimal (number: number) {
    return (Math.round(number * 100) / 100).toFixed(2)
  }
}
